import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="Adgang nægtet (403)"
        description="Du har ikke adgang til denne ressource hos Lunde Media."
      />

      <section className="min-h-[80vh] flex items-center justify-center pt-32 pb-20 px-6">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-none bg-[#18181C] border border-[#B89B72]/30 text-[#B89B72] text-2xl font-serif font-bold">
            403
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#F4EFEA] tracking-tight">
            Adgang ikke tilladt
          </h1>

          <p className="text-zinc-400 text-sm sm:text-base leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne side eller ressource.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-8 py-3.5 rounded-none bg-[#B89B72] hover:bg-[#A68860] text-[#0C0C0D] font-semibold text-sm tracking-wide transition-all shadow-lg"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 rounded-none bg-white/5 hover:bg-white/10 text-white font-medium text-sm tracking-wide transition-all border border-white/10"
            >
              Kontakt Michael
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
